
    (() => {
      const GLOBAL_KEY = '__owMakingVideoController';
      const script = document.currentScript;
      const host = script?.closest('.product-info__liquid');
      const videoBlock = host?.querySelector('.ow-making-video');

      if (!videoBlock) {
        return;
      }

      if (
        window[GLOBAL_KEY] &&
        typeof window[GLOBAL_KEY].destroy === 'function'
      ) {
        window[GLOBAL_KEY].destroy();
      }

      const productSection =
        videoBlock.closest('.shopify-section');

      if (!productSection) {
        return;
      }

      productSection
        .querySelectorAll('.ow-making-video')
        .forEach((existing) => {
          if (existing !== videoBlock) {
            existing.remove();
          }
        });

      const DESKTOP_GAP = 24;
      const BOTTOM_GAP = 8;
      const STICKY_GAP = 18;

      const desktopQuery =
        window.matchMedia('(min-width: 1000px)');

      const video =
        videoBlock.querySelector('video');

      const originalParent =
        videoBlock.parentNode;

      const originalNextNode =
        videoBlock.nextSibling;

      const productLayout =
        productSection.querySelector('.product');

      const gallery =
        productSection.querySelector('.product-gallery');

      const mediaFrame =
        gallery?.querySelector(
          '.product-gallery__media-list-wrapper, .product-gallery__media-list'
        ) || gallery;

      const thumbnailArea =
        gallery?.querySelector(
          '.product-gallery__thumbnail-list-wrapper, .product-gallery__thumbnail-list'
        );

      const originalProductMinHeight =
        productLayout?.style.minHeight || '';

      let destroyed = false;
      let replayTimers = [];
      let positionFrame = null;
      let galleryObserver = null;
      let hostObserver = null;
      const cleanup = [];

      const on = (target, eventName, handler, options) => {
        if (!target) {
          return;
        }

        target.addEventListener(
          eventName,
          handler,
          options
        );

        cleanup.push(() => {
          target.removeEventListener(
            eventName,
            handler,
            options
          );
        });
      };

      const watchQuery = (query, handler) => {
        if (
          typeof query.addEventListener ===
          'function'
        ) {
          query.addEventListener(
            'change',
            handler
          );

          cleanup.push(() => {
            query.removeEventListener(
              'change',
              handler
            );
          });
        } else {
          query.addListener(handler);

          cleanup.push(() => {
            query.removeListener(handler);
          });
        }
      };

      const restoreProductMinHeight = () => {
        if (!productLayout) {
          return;
        }

        if (originalProductMinHeight) {
          productLayout.style.minHeight =
            originalProductMinHeight;
        } else {
          productLayout.style.removeProperty(
            'min-height'
          );
        }
      };

      const clearDesktopPosition = () => {
        videoBlock.style.removeProperty(
          'position'
        );

        videoBlock.style.removeProperty('top');
        videoBlock.style.removeProperty('left');
        videoBlock.style.removeProperty('width');
        videoBlock.style.removeProperty('z-index');

        restoreProductMinHeight();
      };

      function destroy() {
        if (destroyed) {
          return;
        }

        destroyed = true;

        replayTimers.forEach((timer) => {
          window.clearTimeout(timer);
        });

        replayTimers = [];

        if (positionFrame !== null) {
          window.cancelAnimationFrame(
            positionFrame
          );
          positionFrame = null;
        }

        galleryObserver?.disconnect();
        hostObserver?.disconnect();

        cleanup.forEach((removeListener) => {
          removeListener();
        });

        restoreProductMinHeight();

        if (videoBlock.isConnected) {
          videoBlock.remove();
        }

        if (
          window[GLOBAL_KEY]?.videoBlock ===
          videoBlock
        ) {
          delete window[GLOBAL_KEY];
        }
      }

      window[GLOBAL_KEY] = {
        destroy,
        videoBlock
      };

      videoBlock.dataset.owInitialised = 'true';

      const playVideo = () => {
        if (
          destroyed ||
          !video ||
          !video.isConnected
        ) {
          return;
        }

        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;

        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute(
          'webkit-playsinline',
          ''
        );

        const playAttempt = video.play();

        if (
          playAttempt &&
          typeof playAttempt.catch === 'function'
        ) {
          playAttempt.catch(() => {});
        }
      };

      const restartVideo = () => {
        if (destroyed) {
          return;
        }

        replayTimers.forEach((timer) => {
          window.clearTimeout(timer);
        });

        replayTimers = [
          window.setTimeout(playVideo, 0),
          window.setTimeout(playVideo, 250),
          window.setTimeout(playVideo, 1000)
        ];
      };

      const handlePause = () => {
        if (
          !destroyed &&
          !document.hidden
        ) {
          window.setTimeout(playVideo, 150);
        }
      };

      const handleVisibility = () => {
        if (
          !destroyed &&
          !document.hidden
        ) {
          restartVideo();
        }
      };

      const restoreMobilePosition = () => {
        if (destroyed) {
          return;
        }

        clearDesktopPosition();

        if (
          originalParent &&
          originalParent.isConnected &&
          videoBlock.parentNode !== originalParent
        ) {
          if (
            originalNextNode &&
            originalNextNode.parentNode ===
              originalParent
          ) {
            originalParent.insertBefore(
              videoBlock,
              originalNextNode
            );
          } else {
            originalParent.appendChild(
              videoBlock
            );
          }
        }
      };

      const positionVideo = () => {
        if (
          destroyed ||
          !productLayout ||
          !gallery ||
          !mediaFrame
        ) {
          return;
        }

        if (!desktopQuery.matches) {
          restoreMobilePosition();
          return;
        }

        if (
          videoBlock.parentNode !== productLayout
        ) {
          productLayout.appendChild(videoBlock);
        }

        const productRectangle =
          productLayout.getBoundingClientRect();

        const galleryRectangle =
          gallery.getBoundingClientRect();

        const mediaRectangle =
          mediaFrame.getBoundingClientRect();

        const thumbnailRectangle =
          thumbnailArea?.getBoundingClientRect();

        const galleryLowerEdge = Math.max(
          galleryRectangle.bottom,
          mediaRectangle.bottom,
          thumbnailRectangle?.bottom || 0
        );

        const videoTop = Math.ceil(
          galleryLowerEdge -
          productRectangle.top +
          DESKTOP_GAP
        );

        const videoLeft = Math.round(
          mediaRectangle.left -
          productRectangle.left
        );

        const videoWidth =
          Math.round(mediaRectangle.width);

        videoBlock.style.width =
          videoWidth + 'px';

        const videoHeight =
          videoBlock.offsetHeight;

        const requiredHeight = Math.ceil(
          videoTop +
          videoHeight +
          BOTTOM_GAP
        );

        if (
          productLayout.offsetHeight <
          requiredHeight
        ) {
          productLayout.style.minHeight =
            requiredHeight + 'px';
        }

        const updatedProductRectangle =
          productLayout.getBoundingClientRect();

        const header =
          document.querySelector('header');

        const headerRectangle =
          header?.getBoundingClientRect();

        const stickyTop =
          headerRectangle &&
          headerRectangle.bottom > 0 &&
          headerRectangle.bottom < window.innerHeight * 0.4
            ? Math.ceil(headerRectangle.bottom + STICKY_GAP)
            : STICKY_GAP;

        const naturalViewportTop =
          updatedProductRectangle.top +
          videoTop;

        const productBottom =
          updatedProductRectangle.bottom;

        const fixedBottomLimit =
          productBottom -
          videoHeight -
          BOTTOM_GAP;

        if (naturalViewportTop >= stickyTop) {
          videoBlock.style.position = 'absolute';
          videoBlock.style.top =
            videoTop + 'px';
          videoBlock.style.left =
            videoLeft + 'px';
          videoBlock.style.zIndex = '1';
          return;
        }

        if (fixedBottomLimit <= stickyTop) {
          const finalTop = Math.max(
            videoTop,
            productLayout.offsetHeight -
              videoHeight -
              BOTTOM_GAP
          );

          videoBlock.style.position = 'absolute';
          videoBlock.style.top =
            finalTop + 'px';
          videoBlock.style.left =
            videoLeft + 'px';
          videoBlock.style.zIndex = '1';
          return;
        }

        videoBlock.style.position = 'fixed';
        videoBlock.style.top =
          stickyTop + 'px';
        videoBlock.style.left =
          Math.round(mediaRectangle.left) + 'px';
        videoBlock.style.zIndex = '4';
      };

      const schedulePosition = () => {
        if (
          destroyed ||
          positionFrame !== null
        ) {
          return;
        }

        positionFrame =
          window.requestAnimationFrame(() => {
            positionFrame = null;
            positionVideo();
          });
      };

      on(
        video,
        'loadeddata',
        restartVideo
      );

      on(
        video,
        'canplay',
        restartVideo
      );

      on(
        video,
        'ended',
        restartVideo
      );

      on(
        video,
        'pause',
        handlePause
      );

      on(
        window,
        'pageshow',
        restartVideo
      );

      on(
        window,
        'focus',
        restartVideo
      );

      on(
        document,
        'visibilitychange',
        handleVisibility
      );

      on(
        document,
        'touchstart',
        playVideo,
        {
          passive: true,
          capture: true
        }
      );

      on(
        document,
        'pointerdown',
        playVideo,
        {
          passive: true,
          capture: true
        }
      );

      on(
        window,
        'resize',
        schedulePosition
      );

      on(
        window,
        'scroll',
        schedulePosition,
        { passive: true }
      );

      watchQuery(
        desktopQuery,
        schedulePosition
      );

      gallery
        ?.querySelectorAll('img')
        .forEach((image) => {
          if (!image.complete) {
            on(
              image,
              'load',
              schedulePosition,
              { once: true }
            );
          }
        });

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => {
          if (!destroyed) {
            schedulePosition();
          }
        });
      }

      if (
        'ResizeObserver' in window &&
        gallery &&
        mediaFrame
      ) {
        galleryObserver =
          new ResizeObserver(
            schedulePosition
          );

        galleryObserver.observe(gallery);

        if (mediaFrame !== gallery) {
          galleryObserver.observe(
            mediaFrame
          );
        }

        if (thumbnailArea) {
          galleryObserver.observe(
            thumbnailArea
          );
        }
      }

      if ('MutationObserver' in window) {
        hostObserver =
          new MutationObserver(() => {
            if (
              !destroyed &&
              host &&
              !host.isConnected
            ) {
              destroy();
            }
          });

        hostObserver.observe(
          productSection,
          {
            childList: true,
            subtree: true
          }
        );
      }

      positionVideo();
      videoBlock.dataset.owPositioned = 'true';
      restartVideo();
    })();
  
